import React, { useCallback, useEffect, useMemo, useState } from "react";
import { Formik, Form } from "formik";
import { Table, Button, Spinner, Form as RBForm } from "react-bootstrap";
import { eventService } from "../lib/api/event";
import Swal from "sweetalert2";
import { serverImgUrl } from '../config/constants';
import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";
import Zoom from "yet-another-react-lightbox/plugins/zoom";
import { useNavigate } from "react-router-dom";
import { organizationService } from "../lib/api/organization";

interface attendanceList {
  attendanceDate: string;
  latitude: string;
  longitude: string;
  photo: string;
}

interface DoctorItem {
  doctorId: number;
  fmrNo: string;
  doctorName: string;
  latitude: string;
  createdon: string;
  longitude: string;
  contactNumber: string;
  email: string;
  attendanceList: attendanceList[];
}

const DoctorApprovalPage: React.FC = () => {
  const navigate = useNavigate();
  const [selectedEvent, setSelectedEvent] = useState('');
  const [eventData, setEventData] = useState<any[]>([]);
  const [eventId, setEventId] = useState<any>();
  const [selectedOrg, setSelectedOrg] = useState("");
  const [orgData, setOrgData] = useState<any[]>([]);
  const [orgSearchQuery, setOrgSearchQuery] = useState("");

  const [doctordata, setDoctorData] = useState<DoctorItem[]>([]);
  const [selected, setSelected] = useState<number[]>([]);
  const [loading, setLoading] = useState(false);
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [lightBoxImagePath, setLightBoxImagePath] = useState('');
  const [searchMobile, setSearchMobile] = useState("");

  const [currentPage, setCurrentPage] = useState(1);
  const [recordsPerPage, setRecordsPerPage] = useState(15);

  const filteredOrgData = useMemo(() => {
    const normalizedSearch = orgSearchQuery.trim().toLowerCase();
    if (!normalizedSearch) return orgData;
    return orgData.filter((org) =>
      String(org.organizationName || "").toLowerCase().includes(normalizedSearch)
    );
  }, [orgData, orgSearchQuery]);

  useEffect(() => {
    getAllApprovedOrgs();
  }, []);


  const handleEventChange = (event: any) => {
    const value = event.target.value;
    setSelectedEvent(value);
    const eventId = parseInt(value);
    setEventId(eventId);
  };
  const handleOrgChange = async (event: any) => {
    const orgId = event.target.value;
    setSelectedOrg(orgId);
    // reset current selection while loading events for the org
    setSelectedEvent("");
    setEventId("");
    setEventData([]);
    const { success,data } = await eventService.getEventsbyOrgidAndStatus(orgId, "com,apr");
    if (success) {
      setEventData(data);
      // auto-select when only one event is available
      if (data.length === 1) {
        const onlyEventId = data[0].id;
        setSelectedEvent(String(onlyEventId));
        setEventId(onlyEventId);
      }
    }
  };
  const getAllApprovedOrgs = async () => {
    try {
      const { data } = await organizationService.getOrganizationDetailsforVerification('apr');
      if (data.length > 0) {
        setOrgData(data);
      }

    } catch(err) {
      console.error("Error fetching approvals:", err);
    } finally {
      setLoading(false);
    }
  };

  const fetchPendingApprovals = useCallback( async (status: any) => {
    setLoading(true);
    try {
      setDoctorData([]);
      if (eventId && eventId!==undefined && eventId !== null && eventId !== 0) {
        const { success, data } = await eventService.getDoctorDetailsByEventIdStatus(selectedEvent, status);
        if (data && data.length > 0) {
          setDoctorData(data);
        }

      }else{
               Swal.fire({
                title: "",
                text: "Please select Event Id",
                icon: "warning",
                confirmButtonText: "OK",
              }).then(async (result) => {
              });
            }
    } catch (err) {
      console.error("Error fetching approvals:", err);
    } finally {
      setLoading(false);
    }
  }, [eventId]);

  const toggleSelect = (id: number) => {
    setSelected((prev) =>
      prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]
    );
  };


  const selectAll = () => {
    const pageData = paginatedData();
    const pageIds = pageData.map((d) => d.doctorId);

    const allSelected = pageIds.every((id) => selected.includes(id));

    if (allSelected) {
      setSelected((prev) => prev.filter((id) => !pageIds.includes(id)));
    } else {
      setSelected((prev) => Array.from(new Set([...prev, ...pageIds])));
    }
  };

  const handleApprove = async () => {
    if (selected.length === 0) {
      alert("Please select at least one record.");
      return;
    }

    try {
      const formData = new FormData();
      formData.append("ids", JSON.stringify(selected));
      formData.append("status", "apr");
      formData.append("eventId", selectedEvent);
      formData.append("orgId", selectedOrg);

      const { success } = await eventService.updateDoctorApprovals(formData);

      if (success) {
        Swal.fire({
          title: "success",
          text: "Selected records approved successfully!",
          icon: "success",
          confirmButtonText: "OK",
        }).then(async (result) => {
        });
        fetchPendingApprovals('pen');
      }
      setSelected([]);
    } catch (err) {
      console.error("Approval failed:", err);
    }
  };

  const handleReject = async () => {
    if (selected.length === 0) {
      alert("Please select at least one record.");
      return;
    }

    try {
      const formData = new FormData();
      formData.append("ids", JSON.stringify(selected));
      formData.append("status", "rej");
      formData.append("eventId", selectedEvent);
      formData.append("orgId", selectedOrg);
      
      const { success } = await eventService.updateDoctorApprovals(formData);
      if (success) {
        Swal.fire({
          title: "success",
          text: "Selected records Rejected successfully!",
          icon: "success",
          confirmButtonText: "OK",
        }).then(async (result) => {
        });
        fetchPendingApprovals('pen');
      }

      setSelected([]);
    } catch (err) {
      console.error("Rejection failed:", err);
    }
  };

  const filteredDoctors = doctordata.filter((doc) =>
  searchMobile.trim()
    ? doc.contactNumber?.includes(searchMobile.trim())
    : true
);

  const totalPages = Math.ceil(filteredDoctors.length / recordsPerPage);


  const paginatedData = () => {
    const start = (currentPage - 1) * recordsPerPage;
    return filteredDoctors.slice(start, start + recordsPerPage);
  };


  const handlePageChange = (page: number) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  if (loading) {
    return (
      <div className="d-flex justify-content-center mt-5">
        <Spinner animation="border" />
      </div>
    );
  }

  

  return (
    <div className="container mt-4 cpd-shell">
      <h3 className="mb-3 text-center cme-header">Doctor Approvals</h3>
      <Formik initialValues={{}} onSubmit={() => { }}>
        <Form>
          <div className="row p-3">
            <div className="col-md-4"><b>Select Organization Name</b></div>
            <div className="col-md-4">
             <input
                type="text"
                className="form-control mt-1"
                placeholder="Filter organization by keyword"
                value={orgSearchQuery}
                onChange={(e) => setOrgSearchQuery(e.target.value)}
              />
             <select
                name="organizationType"
                  value={selectedOrg}
                  onChange={handleOrgChange}
                  className="form-select org-name-wrap mt-1"
                  >
                      <option value="" disabled>
                        --Please choose an option--
                      </option>

                    {filteredOrgData.map((orgtype) => (
                      <option key={orgtype.id} value={orgtype.id}>
                        {orgtype.organizationName}
                      </option>
                    ))}
                    {filteredOrgData.length === 0 && (
                      <option value="" disabled>
                        No organization found
                      </option>
                    )}
                  </select>

            </div>
            <div>


              <div className="row p-3">
                <div className="col-md-4"><b>Select Event Name</b></div>
                <div className="col-md-4">
                  <select name="EventType"
                    value={selectedEvent} // Binds the select value to the state variable.
                    onChange={handleEventChange}
                    className="form-select">
                    <option value="" disabled>--Please choose an option--</option>
                    {eventData.map((type) => (
                      <option key={type.id} value={type.id}>
                        {type.nameOfEvent}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            </div>
          </div>
          <div className="row mb-3">
            <div className="col-md-6 d-flex flex-wrap gap-2">
              <Button variant="info" onClick={() => fetchPendingApprovals("pen")}>
                Pending
              </Button>
              <Button variant="primary" onClick={() => fetchPendingApprovals("apr")}>
                Approved
              </Button>
              <Button variant="warning" onClick={() => fetchPendingApprovals("rej")}>
                Rejected
              </Button>
            </div>

            <div className="col-md-6 d-flex justify-content-end align-items-center flex-wrap gap-2">
              <Button variant="success" onClick={handleApprove}>
                Approve Selected
              </Button>
              <Button variant="danger" onClick={handleReject}>
                Reject Selected
              </Button>
            </div>
          </div>

          <div className="d-flex justify-content-end mb-3">
            <input
              type="text"
              className="form-control w-25"
              placeholder="Search by Contact Number"
              value={searchMobile}
              onChange={(e) => {
                setSearchMobile(e.target.value);
                setCurrentPage(1); // reset page on search
              }}
            />
          </div>

          {/* Pagination Controls & Page Size */}
          <div className="d-flex align-items-center flex-wrap gap-3 mb-2 w-100">
            <div className="d-flex align-items-center gap-2">
              <RBForm.Label className="mb-0 fw-semibold">Rows per page</RBForm.Label>
              <RBForm.Select
                size="sm"
                value={recordsPerPage}
                onChange={(e) => {
                  setRecordsPerPage(Number(e.target.value));
                  setCurrentPage(1);
                }}
                style={{ width: "auto" }}
              >
                {[10, 15, 25, 50, 100].map((size) => (
                  <option key={size} value={size}>
                    {size}
                  </option>
                ))}
              </RBForm.Select>
            </div>

            {totalPages > 1 && (
              <div className="d-flex justify-content-center align-items-center gap-2 pagination-scroll-wrap ms-auto">
                <Button
                  size="sm"
                  variant="outline-secondary"
                  onClick={() => handlePageChange(1)}
                  disabled={currentPage === 1}
                >
                  « First
                </Button>
                <Button
                  size="sm"
                  variant="outline-secondary"
                  onClick={() => handlePageChange(currentPage - 1)}
                  disabled={currentPage === 1}
                >
                  ‹ Prev
                </Button>
                <RBForm.Select
                  size="sm"
                  value={currentPage}
                  onChange={(e) => handlePageChange(Number(e.target.value))}
                  style={{ width: "auto" }}
                >
                  {[...Array(totalPages)].map((_, i) => (
                    <option key={i} value={i + 1}>
                      Page {i + 1} of {totalPages}
                    </option>
                  ))}
                </RBForm.Select>
                <Button
                  size="sm"
                  variant="outline-secondary"
                  onClick={() => handlePageChange(currentPage + 1)}
                  disabled={currentPage === totalPages}
                >
                  Next ›
                </Button>
                <Button
                  size="sm"
                  variant="outline-secondary"
                  onClick={() => handlePageChange(totalPages)}
                  disabled={currentPage === totalPages}
                >
                  Last »
                </Button>
              </div>
            )}
          </div>

          <div className="table-scroll-x">
          <Table bordered hover responsive className="align-middle doctor-table shadow-sm">
            <thead className="table-primary">
              <tr>
                <th>
                  <input
                    type="checkbox"
                    onChange={selectAll}
                    checked={
                      paginatedData().every((i) => selected.includes(i.doctorId)) &&
                      paginatedData().length > 0
                    }
                  />
                </th>
                <th>Doctor Name</th>
                <th>FMR No</th>
                <th>Contact Number</th>
                <th>Email</th>
                <th>Photo</th>
              </tr>
            </thead>
            <tbody>
              {paginatedData().length === 0 ? (
                <tr>
                  <td colSpan={7} className="text-center text-muted">
                    No pending approvals
                  </td>
                </tr>
              ) : (
                paginatedData().map((item) => (
                  <tr key={item.doctorId}>
                    <td>
                      <input
                        type="checkbox"
                        checked={selected.includes(item.doctorId)}
                        onChange={() => toggleSelect(item.doctorId)}
                      />
                    </td>
                    <td>{item.doctorName}</td>
                    <td>{item.fmrNo}</td>
                    <td>{item.contactNumber}</td>
                    <td>{item.email}</td>
                    <td>
                       <div className="photo-grid">
                      {item.attendanceList.map((photos) =>
                        <div
                          className="photo-card"
                          onClick={() => {
                            setLightBoxImagePath(photos.photo); setLightboxOpen(true);
                          }}
                          key={photos.photo + photos.attendanceDate}
                        >
                          
                           <p className="photo-date">Date: {photos.attendanceDate}</p>
                          {<img src={serverImgUrl + '/photos/' + photos.photo} alt="" width={60} height={60} />}
                          <p className="photo-coord">Lat :{photos.latitude}</p>
                          <p className="photo-coord">Long:{photos.longitude}</p>
                        </div>
                      )
                      }
                      </div>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </Table>
          </div>
        </Form>
      </Formik>

      <div>
        <Lightbox
          open={lightboxOpen}
          plugins={[Zoom]}
          close={() => setLightboxOpen(false)}
          slides={[
            {
              src: serverImgUrl + '/photos/' + lightBoxImagePath,
              alt: "edu_cert1",
              width: 3840,
              height: 2560,
              srcSet: [
                { src: serverImgUrl + '/photos/' + lightBoxImagePath, width: 100, height: 100 },
              ]
            }
          ]}
        />
      </div>
    </div>
  );
};

export default DoctorApprovalPage;
